<script lang="ts">
  import { isMobile } from '../../../common/util';
  import { getStr } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';

  export let titleKey;
  export let titleText = '';
  export let subtitleKey = null;
  export let icon;
  export let iconType = 'primary';
  export let appleCareTitleDetails = null;
  export let VariantSectionCard = false;
  export let initiallyExpanded = true;

  const { imageUrl, label, code = 'pdp-services-container' } = appleCareTitleDetails || {};
  const isMobileView = isMobile();
  let isExpanded = isMobileView ? true : initiallyExpanded;

  function toggleCard() {
    if (isMobileView) {
      return;
    }
    isExpanded = !isExpanded;
  }
</script>

<section class="pdp-section-card accordion-section-card {code}">
  <button type="button" class="card-header-btn" on:click={toggleCard}>
    <section class="card-title">
      {#if appleCareTitleDetails}
        <img src={imageUrl} alt={label} title={label} />
        <h2>{label}</h2>
      {:else}
        {#if VariantSectionCard}
          <Icon desktopSize={33} mobileSize={30} glyph={icon} type="url" />
        {:else}
          <Icon type={iconType} desktopSize={36} mobileSize={30} glyph={icon} />
        {/if}
        <section class="title-subtitle">
          <h2>
            {titleText || getStr(titleKey)}
          </h2>
          {#if subtitleKey?.length > 0}
            <p class="subtitle">{getStr(subtitleKey)}</p>
          {/if}
        </section>
      {/if}
    </section>
    <section class="card-title-meta">
      <span class="card-title-meta-text {isExpanded && 'hide'}"><slot name="header-right"></slot></span>
      {#if !isMobileView}
        <Icon type="font" glyph={isExpanded ? 'chevron_up' : 'chevron_down'} desktopSize={20} mobileSize={20} />
      {/if}
    </section>
  </button>

  {#if isExpanded}
    <section class="card-content">
      <slot></slot>
    </section>
  {/if}
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .pdp-section-card.accordion-section-card {
    margin: 10px 0;
    padding: 10px 16px;
    background-color: $neutral-light-04;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    @include desktop-max-width {
      margin: 8px 0;
      padding: 10px 8px;
      gap: 6px;
    }

    .card-header-btn {
      border: none;
      background: transparent;
      padding: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      cursor: pointer;
    }

    .card-title {
      display: flex;
      gap: 8px;
      align-items: center;
      min-width: 0;

      h2 {
        padding: 0;
        flex-grow: 1;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        color: $neutral-dark-01;
        margin: 0;

        @include desktop-min-width {
          font-size: 18px;
        }
      }

      .subtitle {
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
        margin-block: -8px 0;
      }
    }

    .card-title-meta {
      display: flex;
      align-items: center;
      gap: 12px;
      color: $primary-blue;
      flex-shrink: 0;
      @include desktop-max-width {
        display: none;
      }
    }
    .card-content {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding-bottom: 10px;
      @include desktop-max-width {
        gap: 4px;
        padding-bottom: 0;
      }
    }
  }
</style>
